export const getStatusEmoji = (text: string) => {
  const lowerText = text.toLowerCase();

  if (lowerText.includes('started')) return '⚪️';
  if (lowerText.includes('outdated')) return '🟠';
  if (lowerText.includes('finalized')) return '🟢';

  return '🔵';
};
